<template>
  <div>
    <div class="maintitle">{{title}}</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="10">
      <el-col :span="6">
        <el-input v-model='keyword' size="mini" placeholder="请输入搜索关键字" @keyup.enter.native="srch"></el-input>
      </el-col>
      <el-col :span='14'>
        <el-button type="success" size="mini" @click="srch" class="margin-left">查找</el-button>
      </el-col>
    </el-row>
    <el-table :data="list" row-key="id" border :stripe='true'>
      <el-table-column label="公司名" prop='company'></el-table-column>
      <el-table-column label="联系电话" width='120'>
        <template slot-scope="scope">
          <span v-html='formatTel(scope.row.tel)'></span>
        </template>
      </el-table-column>
      <el-table-column prop="contact" label="联系人" width='80'></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column label="报备业务">
        <template slot-scope="scope">
          <span v-html='formatType(scope.row.type)'></span>
        </template>
      </el-table-column>
      <el-table-column label="入海原因">
        <template slot-scope="scope">
          <span>{{formatReason(scope.row.tichuyuanyin)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width='80'>
        <template slot-scope="scope">
          <el-button type='text' @click="tiaoru(scope)">挑入</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
  </div>
</template>

<script>
import Template from '../../kaohe/setting/template.vue';
export default {
  data() {
    return {
      list: [], //员工列表
      title: "",
      page: 1,
      total: 0,
      keyword:'',
      departmentlist: JSON.parse(sessionStorage.getItem('departmentlist')),
      sourcelist: JSON.parse(sessionStorage.getItem('sourcelist')),
      yixianglist: JSON.parse(sessionStorage.getItem('yixianglist')),
      hangyelist: JSON.parse(sessionStorage.getItem('hangyelist')),
      typelist: JSON.parse(sessionStorage.getItem('alltypelist')),
      reasonlist: JSON.parse(sessionStorage.getItem('reasonlist')),
    };
  },
  methods: {
    srch() {
      this.page = 1;
      this.getlist();
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/baobei/baobei/gonghai",
        method: "post",
        data: {
          keyword: this.keyword,
          page: this.page,
          pagesize: this.pagesize,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
        }
      });
    },
    formatType(type) {
      let temp = [];
      for (let i in type) {
        for (let item in this.typelist) {
          if (this.typelist[item].id == type[i]) {
            temp.push(this.typelist[item].name);
          }
        }
      }
      return temp.join('<br />');
    },
    formatTel(tel){
      let temp = tel.split(';');
      return temp.join('<br />');
    },
    formatReason(reason){
      for (let item in this.reasonlist) {
        if (this.reasonlist[item].id == reason) {
          return this.reasonlist[item].reason;
        }
      }
      return "未知";
    },
    tiaoru(scope) {
      this.$confirm('确定要将' + scope.row.company + '挑入到私人报备吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          url: this.HOST + '/baobei/baobei/tiaoru',
          method: 'post',
          data: {id: scope.row.id}
        }).then(res => {
          if (res.data.status == 1) {
            this.$message({
              type: 'info',
              message: res.data.info
            })
            this.list.splice(scope.$index, 1);
          }
        })
      })
    },
  },
  created: function () {
    this.title = this.$route.meta.title;
    for (let item in this.baobeiinfo) {
      this.tempinfo[item] = this.baobeiinfo[item];
    }
    this.getlist();
  },
};
</script>
<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 120px;
  color: #99a9bf;
  text-align: right !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>